//import React from 'react';
import CategoryList from '../components/CategoryList';
//import BannerProduct from '../components/BannerProduct';
//import HorizontalCardProduct from '../components/HorizontalCardProduct';
import VerticalCardProduct from '../components/VerticalCardProduct';
import HomeImage from '../components/HomeImage';

const Home = () => {
  return (
    
    <div>
      <HomeImage/>
      <CategoryList/>
      <div><h2 className='home-heading'>Earings</h2><VerticalCardProduct category={"earings"} /></div>
      <div><h2 className='home-heading'>Chandbalis</h2><VerticalCardProduct category={"chandbalis"} /></div>
      <div><h2 className='home-heading'>Anti Tarnish</h2><VerticalCardProduct category={"anti tarnish"} /></div>
      <div><h2 className='home-heading'>Bangles</h2><VerticalCardProduct category={"bangles"} /></div>      
      <div><h2 className='home-heading'>Claw Clips</h2><VerticalCardProduct category={"claw clips"} /></div>
      <div><h2 className='home-heading'>Hair Accessories</h2><VerticalCardProduct category={"hair accessories"} /></div>
      <div><h2 className='home-heading'>Bracelets</h2><VerticalCardProduct category={"bracelets"} /></div>
      <div><h2 className='home-heading'>Jewellery Sets</h2><VerticalCardProduct category={"jewellery sets"} /></div>
      <div><h2 className='home-heading'>Nose Pins</h2><VerticalCardProduct category={"nose pins"} /></div>
      <div><h2 className='home-heading'>Rings</h2><VerticalCardProduct category={"rings"} /></div>
      <div><h2 className='home-heading'>Neckless</h2><VerticalCardProduct category={"neckless"} /></div>
      <div><h2 className='home-heading'>Mangalsutra</h2><VerticalCardProduct category={"mangalsutra"} /></div>
    </div>
    
  )
}

export default Home;